<template>
  <Table stripe :columns="attributes" :data="tableData">
  </Table>
</template>

<script>
export default {
  name: 'view-repeat-domain',
  data: function () {
    return {
      showEdit: false,
      showDel: false
    }
  },
  computed: {
    attributes: function () {
      var attrs = []
      attrs.push({
        title: '序号',
        sortable: true,
        fixed: 'left',
        key: 'seq',
        width: 80
      })
      for (var i in this.items[0]) {
        var item = this.items[0][i]
        var unit = item.unit ? ('(' + item.unit + ')') : ''
        var attr = {
          title: item.question + unit,
          sortable: true,
          key: item.var_name.toLowerCase()
        }
        if (item.var_width) {
          attr['width'] = item.var_width
        }
        attrs.push(attr)
      }
      return attrs
    },
    tableData: function () {
      var records = []
      for (var m in this.items) {
        var record = {}
        record['seq'] = this.items[m][0].data.seq
        for (var i = 0; i < this.items[m].length; i++) {
          var item = this.items[m][i]
          var val = item.data.val
          if (item.codes !== false) {
            val = item.codes[item.data.val]
          }
          record[this.items[m][i].var_name.toLowerCase()] = val
        }
        records.push(record)
      }
      return records
    }
  },
  props: ['items'],
  methods: {
    addRecord: function () {
      this.$emit('addRecord')
    },
    refresh: function () {
      this.$emit('refresh')
    },
    hasNewQuery: function (row) {
      var num = 0
      for (var i = 0; i < row.length; i++) {
        num = num + row[i].data.query.new
      }
      return num > 0
    },
    haseAnsweredQuery: function (row) {
      var num = 0
      for (var i = 0; i < row.length; i++) {
        num = num + row[i].data.query.answered
      }
      return num > 0
    }
  }
}
</script>
